import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var newPathname = function newPathname(_ref) {
  var params = _ref.params,
      newValues = _ref.newValues;

  var newParams = _objectSpread(_objectSpread({}, params), newValues);

  var newPath = Object.keys(newParams).reduce(function (res, cur) {
    if (!newParams[cur]) return res;
    return "".concat(res).concat(newParams[cur], "/");
  }, '/');
  return newPath;
};
export var newSearch = function newSearch(_ref2) {
  var params = _ref2.params,
      newValues = _ref2.newValues;

  var newParams = _objectSpread(_objectSpread({}, params), newValues);

  var newSearchStr = Object.keys(newParams).reduce(function (res, cur) {
    if (!newParams[cur].length) {
      return res;
    }

    if (Array.isArray(newParams[cur])) {
      var list = newParams[cur].join(',');
      return res ? "".concat(res, "&").concat(cur, "=").concat(list) : "?".concat(cur, "=").concat(list);
    }

    return res ? "".concat(res, "&").concat(cur, "=").concat(String(newParams[cur])) : "?".concat(cur, "=").concat(String(newParams[cur]));
  }, '');
  return newSearchStr;
};
export var getAbsoluteMinfinLink = function getAbsoluteMinfinLink(relativePath) {
  return "".concat(process.env.APP_MINFIN_DOMAIN).concat(relativePath);
};